// extracted by mini-css-extract-plugin
export default {"side-modal-link-operation-table":"side-modal-link-operation_side-modal-link-operation-table__VkgE3"};